export const numberOfDaysBeforeTheFeedbackPopoverIsShownAgain = 5;
